import { EnrichedSubscription } from 'v2/models';

const pairConflictPermissions = [
  ['create-internal-search', 'create-search'],
  ['create-internal-search', 'review-search-org'],
  ['create-internal-search', 'review-search-master-org'],
  ['review-search-org', 'review-search-master-org'],
];

export const formatTooltipName = (name: string) => {
  let currentName = name.replaceAll('-', ' ');
  currentName = `${currentName.charAt(0).toUpperCase()}${currentName.slice(1)}`;
  return currentName;
};

const validatePermissions = (
  permissionOne: string,
  permissionTwo: string,
  subscription: EnrichedSubscription,
  checkedSubscriptions: EnrichedSubscription[]
): [boolean, string] => {
  const currentName = formatTooltipName(subscription.plan_fk.name);
  if (subscription.remaining === 0 && !subscription.selected) {
    return [true, `No ${currentName} licenses are available`];
  }

  const firstPermission = subscription.permissions.find(
    (per) => per.permission.permission_name === permissionOne
  );
  const checkedSubscription = checkedSubscriptions.find((sub) =>
    sub.permissions.find(
      (per) => per.permission.permission_name === permissionTwo
    )
  );

  if (firstPermission) {
    if (checkedSubscription) {
      const targetName = formatTooltipName(checkedSubscription.plan_fk.name);
      return [
        true,
        `User cannot be assigned to both ${currentName} and ${targetName} licenses`,
      ];
    }
  }
  return [false, ''];
};

export const validateRestrictions = (
  subscription: EnrichedSubscription,
  localSubscriptions: EnrichedSubscription[]
): [boolean, string] => {
  const checkedSubscriptions = localSubscriptions.filter(
    (subs) => subs.selected && subs.id !== subscription.id
  );
  for (const pair of pairConflictPermissions) {
    for (let i = 0, j = 1; i < pair.length; i++, j--) {
      const conflictPermission = validatePermissions(
        pair[i],
        pair[j],
        subscription,
        checkedSubscriptions
      );
      if (conflictPermission[0]) {
        return conflictPermission;
      }
    }
  }
  return [false, ''];
};
